import React from 'react';
import { TransparentFlatButton } from '@ui/buttons';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper } from '@flow/styles';
import { Container, Body5 } from '@ui';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';

export const StringListParameter = ({ data, value, onRemove, onChange }) => {
  const { keyName, label } = data;

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const syncItems = () => {
      if (Array.isArray(value)) {
        setItems(value);
      } else {
        setItems([value]);
      }
    };
    syncItems();
  }, []);

  React.useEffect(() => {
    onChange(
      keyName,
      items.filter((el) => el !== '')
    );
  }, [items]);

  const handleAddItem = () => {
    setItems((prevItems) => [...prevItems, '']);
  };
  const handleChange = (e, i) => {
    const value = e.target.value;
    setItems((prevItems) => {
      const copy = [...prevItems];
      copy[i] = value;
      return copy;
    });
  };
  const handleRemoveClick = () => {
    onRemove(keyName);
  };

  const handleRemoveItemClick = (i) => {
    setItems((prevItems) => {
      const copy = [...prevItems];
      return copy.filter((el, elIndex) => elIndex !== i);
    });
  };

  return (
    <AgentFlowParameterWrapper>
      <Container fullWidth>
        <Container row verticallyCenter spaceBetween fullWidth>
          <Container row verticallyCenter>
            <AgentFlowParameterLabelWrapper>
              <Body5>{label}:</Body5>
            </AgentFlowParameterLabelWrapper>
            <div className="read-only-hide">
              <TransparentFlatButton onClick={handleAddItem}>Add List Item</TransparentFlatButton>
            </div>
          </Container>

          <NodeParameterRemoveButton onClick={handleRemoveClick} />
        </Container>
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              <Container fullWidth row verticallyCenter>
                {keyName === 'query_list' ? (
                  <textarea value={item} onChange={(e) => handleChange(e, index)} />
                ) : (
                  <input value={item} onChange={(e) => handleChange(e, index)} />
                )}

                <NodeParameterRemoveButton onClick={() => handleRemoveItemClick(index)} />
              </Container>
            </li>
          ))}
        </ul>
      </Container>
    </AgentFlowParameterWrapper>
  );
};
